module.exports = __webpack_public_path__ + "9edee9675e1d22de54b17e385232adf0.svg";